import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Auto-scroll to top when navigating between routes.
// Place once inside <BrowserRouter>.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    try { window.scrollTo({ top: 0, left: 0, behavior: "instant" }); }
    catch { window.scrollTo(0, 0); }
  }, [pathname]);
  return null;
}
